import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import { limitLength } from '../../utils';
import styles from './styles.css';
import messages from './messages';

const CancelTransferForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.cancelTransfer} />}
    submitLabel={<FormattedMessage {...messages.cancelBtn} />}
    cancelLabel={<FormattedMessage {...messages.closeBtn} />}
  >
    <ControlLabel htmlFor="reason" className={styles.commentLabel}>
      <FormattedMessage {...messages.commentSubTitle} />
      <Field
        name="reason"
        component="textarea"
        className="form-control"
        normalize={(value) => limitLength(value, 100)}
      />
    </ControlLabel>
  </ModalForm>
);


CancelTransferForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'CancelTransfer', enableReinitialize: true })(CancelTransferForm);



// WEBPACK FOOTER //
// ./src/components/CancelTransferForm/index.js